import { DEFAULT_PAGINATION_PAGE } from '@/common/constants/page';

import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: {
    monitoringPage: { ...DEFAULT_PAGINATION_PAGE },
    updateStatuses: [],
    sources: [],
    loadError: false,
  },
};
